import Modal from "react-bootstrap/Modal";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CloseIconContainer, CornerRoundImg } from "../common-styling";

const VerticallyCenteredModal = (props) => {
  return (
    <Modal {...props} size="lg" centered>
      <CornerRoundImg src={props.source} />
      <CloseIconContainer onClick={props.onHide}>
        <FontAwesomeIcon icon={faClose} className="text-danger" />
      </CloseIconContainer>
    </Modal>
  );
};

const ImagePreviewModal = ({ source, toggleModal }) => {
  return (
    <VerticallyCenteredModal source={source} show={true} onHide={toggleModal} />
  );
};
export default ImagePreviewModal;
